import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// Initialize Sentry before the app bootstraps. An empty dsn (local dev, or an
// unset SENTRY_DSN in a deployed build) disables Sentry cleanly.
if (environment.sentry.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false, // GDPR — keep false
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
